<div class="table-container">
  <table class="table">
    <thead>
      <tr>
        <th class="title-header">
          <button
            class="plus"
            *ngIf="!showCreateForm"
            (click)="createInvolved()"
          >
            <i class="fa fa-plus" aria-hidden="true"></i>
          </button>
        </th>
      </tr>
    </thead>

    <tbody>
      <tr *ngIf="showCreateForm">
        <td colspan="1">
          <div class="create-involved-form">
            <involved-details
              [currentTicket]="currentTicket"
              (formClosed)="onFormClosed()"
            ></involved-details>
          </div>
        </td>
      </tr>

      <ng-container *ngFor="let involved of involveds | async">
        <tr>
          <td class="td user-cell">
            <span class="user-info">
              <i class="material-icons">person</i> {{ userLabel(involved) }}
            </span>
            <button class="btn-delete" (click)="removeInvolved(involved)">
              <span class="material-icons-outlined">cancel</span>
            </button>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>
